module.exports = __webpack_public_path__ + "static/media/640.d26c0ce7.jpg";